<div class="container">
  <div class="chat-bot" [style.borderColor]="chatBotSetting.headerColor">
    <div class="chat-bot-header" [style.background]="chatBotSetting.headerColor">
      <span class="chat-bot-icon" [style.borderColor]="chatBotSetting.headerColor">
        <img [src]="chatBotSetting.iconFilePath" width="17" height="22" class="mlt-10" />
      </span>
      <label class="chat-bot-header-text"
      [class.textColorGrey]="chatBotSetting.invertTextColor">{{chatBotSetting.title}}</label>
      <button class="close-action" (click)="closeTranscriptHistory()">
        <img src="./assets/images/Ava_chat/Close_icon.svg" width="13" height="33" />
      </button>
    </div>
    <div class="row">
      @for (chathistory of chatTranscriptHistory; track chathistory; let j = $index) {
        <span class="chat-bot-date">
          @if (j==1) {
            <label>{{chathistory.chatTime |date: 'MM/dd/yyyy'}}</label>
          }
          @if (j==1) {
            <a>
              {{chathistory.chatTime |date:' h:mm a' |lowercase}}
            </a>
          }
        </span>
      }
    </div>
    <div class="chat-bot-content chatTranscript">
      @for (chat of chatTranscriptList; track chat; let i = $index) {
        <div>
          <div class="row mt-3">
            @for (chathistory of chatTranscriptHistory; track chathistory) {
              <div class="content-response"
                [style.margin-top.px]="i!=0 && (chat.senderId == 3 && showIcon(chathistory.senderId, i))?-30:0"
                >
                <div class="row " [class.typing-msg]="chathistory.senderId == 3 "
                  [style.border-color]="chatBotSetting.headerColor">
                  @if (chathistory.senderId != 3) {
                    <span class="chat-bot-icon-sm" [style.borderColor]="chatBotSetting.headerColor"
                      >
                      <img src="./assets/images/Ava_chat/Sender_icon.svg" width="20" height="12" class="set-icon-sm" />
                    </span>
                  }
                  <a [class.chat-bot-content-text]="chathistory.senderId != 3 ">{{ chathistory.text }}</a>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>